import React, { Fragment, Suspense } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ClimbingBoxLoader } from 'react-spinners';
import MainPage from 'uos/home'
import RegisterPage from 'register'

import MainLayout from 'uos_admin/mainLayout'
import PostEditor from 'uos_admin/post_editor'
import LoginPage from 'login';
import ForgetPassowrd from 'forgetPassword';

const Routes = () => {

  const location = useLocation();
  const isLogin = window.localStorage.getItem('ch_isLogin') === "0" ? false : true;
  const pageVariants = {
    initial: {
      opacity: 0,
      scale: 0.99
    },
    in: {
      opacity: 1,
      scale: 1
    },
    out: {
      opacity: 0,
      scale: 1.01
    }
  };

  const pageTransition = {
    type: 'tween',
    ease: 'anticipate',
    duration: 0.4
  };

  const SuspenseLoading = () => {
    return (
      <Fragment>
        <div className="d-flex align-items-center flex-column vh-100 justify-content-center text-center py-3">
          <div className="d-flex align-items-center flex-column px-4">
            <ClimbingBoxLoader color={'#3c44b1'} loading={true} />
          </div>
          <div className="text-muted font-size-xl text-center pt-3">
            Please wait while we load the live preview examples
              <span className="font-size-lg d-block text-dark">
              This live preview instance can be slower than a real production
              build!
              </span>
          </div>
        </div>
      </Fragment>
    );
  };
  return (
    <AnimatePresence>
      <Suspense fallback={<SuspenseLoading />}>
        <Switch>
          <Route exact path="/"
            render={() => (<Redirect to="/home/all" />)}
          />
          <Route
            path={[
              '/login',
              '/registeration',
              '/forget_password',
              '/home/:id',
              '/resource/:id',
              '/single_event/:id',
              '/event_editor/:id',
              '/admin_login',
              '/admin'
            ]}>
            <div>
              <Switch location={location} key={location.pathname}>
                 <Route
                    exact path="/event_editor/:pid" render={(props) => (!isLogin ? (<Redirect to="/home/all"/>) : ( <PostEditor {...props} />))}
                  />
                <Route exact path="/forget_password" component={ForgetPassowrd} />
                <Route exact path="/admin_login" component={LoginPage} />
                <Route exact path="/registeration" component={RegisterPage} />
                <Route exact path="/home/:id"  render={(props) => (<MainPage {...props} pageName="home" />)}/>
                {/* <Route exact path="/home/events"  render={(props) => (<MainPage option={"events"} {...props} />)} />
                <Route exact path="/home/resource"  render={(props) => (<MainPage option={"resource"} {...props} />)} /> */}
                <Route exact path="/single_event/:id" render={(props) => (<MainPage pageName={"single_event"} {...props} />)} />
                <Route exact path="/resource/:id" render={(props) => (<MainPage pageName={"resource"} {...props} />)} />
                <Route exact path="/admin" render={(props) => (<MainLayout {...props} is_admin_page={1} />)} />
              </Switch>
            </div>
          </Route>
          <Route path="/*"
            render={() => (!isLogin ? (<Redirect to="/home/all" />) : (<Redirect to="/home/all" />))}
          />
        </Switch>
      </Suspense>
    </AnimatePresence>
  );
};

export default Routes;
